import { render, staticRenderFns } from "./myCourse.vue?vue&type=template&id=f170a0c0&scoped=true"
import script from "./myCourse.vue?vue&type=script&lang=js"
export * from "./myCourse.vue?vue&type=script&lang=js"
import style0 from "./myCourse.vue?vue&type=style&index=0&id=f170a0c0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f170a0c0",
  null
  
)

export default component.exports